import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Pressable, StyleProp, View, ViewStyle } from 'react-native';

interface PaymentsListItemProps {
  bottomLeft?: React.ReactElement;
  bottomRight?: React.ReactElement;
  containerStyle?: StyleProp<ViewStyle>;
  isSelected?: boolean;
  leftComponent?: React.ReactNode;
  onPress?: () => void;
  testID?: string;
  topLeft?: React.ReactElement;
  topRight?: React.ReactElement;
}

export const PaymentsListItem: React.FC<PaymentsListItemProps> = ({
  bottomLeft,
  bottomRight,
  containerStyle,
  isSelected,
  leftComponent,
  onPress,
  testID,
  topLeft,
  topRight,
}) => {
  const [styles] = useStyles();

  return (
    <Pressable
      disabled={!onPress}
      onPress={onPress}
      style={({ hovered, pressed }) => [
        styles.container,
        ...(hovered || isSelected ? [styles.containerHighlighted] : []),
        ...(pressed
          ? [styles.containerHighlighted, styles.containerPressed]
          : []),
        ...(containerStyle ? [containerStyle] : []),
      ]}
      testID={testID}
    >
      <View style={styles.row}>
        {leftComponent}
        <View style={styles.content}>
          <View style={styles.contentRow}>
            <View style={styles.leftSlot}>{topLeft}</View>
            {topRight}
          </View>
          {bottomLeft || bottomRight ? (
            <View style={styles.contentRow}>
              <View style={styles.leftSlot}>{bottomLeft}</View>
              {bottomRight}
            </View>
          ) : null}
        </View>
      </View>
    </Pressable>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.sk.color.bg.primary.default,
    paddingHorizontal: theme.sk.spacing.spaceMedium,
    paddingVertical: theme.sk.spacing.spaceSMedium,
  },
  containerHighlighted: {
    backgroundColor: theme.sk.color.bg.secondary.default,
  },
  containerPressed: {
    opacity: 0.5,
  },
  content: {
    flex: 1,
  },
  contentRow: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSMedium,
    justifyContent: 'space-between',
  },
  leftSlot: {
    flex: 1,
    flexShrink: 1,
  },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSMedium,
  },
}));
